import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { TipoProduto } from "../enum/TipoProduto";
import { MIMETypes } from "../../core/enum/MIMETypes";
import { IImagemProduto } from "../interfaces/IImagemProduto";
import { IBorda } from "../interfaces/IBorda";
import { ISabor } from "../interfaces/ISabor";
import { SelectChangeEvent } from "@mui/material";
import { v4 } from "uuid";
import { useSnackbar } from "../../core/contexts/SnackbarContext";
import { yupResolver } from "@hookform/resolvers/yup";
import { FieldValues, UseFormReturn, useForm } from "react-hook-form";
import { configuracaoPizzaSchema } from "../schema/configuracaoPizzaSchema";
import { ModeloPrecificacaoPizza } from "../enum/ModeloPrecificacaoPizza";
import { useNavigate, useParams } from "react-router-dom";
import { useProdutos } from "../hooks/useProdutos";
import { useFetchCategorias } from "../hooks/useFetchCategorias";
import { ICategoria } from "../interfaces/ICategoria";
import { IProduto } from "../interfaces/IProduto";
import { useCategorias } from "../hooks/useCategorias";
import { IImpostoProduto } from "../interfaces/IImpostoProduto";
import { useMoeda } from "../../core/hooks/useMoeda";
import { validarMoedaReal } from "../../core/utils/validarMoedaReal";
import { IComplemento } from "../interfaces/IComplemento";
import { TipoControleEstoque } from "../enum/TipoControleEstoque";
import { IInsumo } from "../interfaces/IInsumo";
import { useMarketplaces } from "../../marketplace/hooks/useMarketplaces";
import { TipoMarketplace } from "../../marketplace/enum/TipoMarketplace";
import { IMassa } from "../interfaces/IMassa";
import { IConfiguracaoPeso } from "../interfaces/IConfiguracaoPeso";
import { IConfiguracaoKDS, IProcessoPreparoKDS } from "../../kds/interfaces/IKDS";
import { IAdicionalPizza } from "../interfaces/IAdicionalPizza";
import { useConfiguracaoKDS } from "../../cozinha/hooks/useConfiguracaoKDS";
import { IItemCombo } from "../interfaces/IItemCombo";
import { mapModeloPizzaParaPrecificacao } from "../utils/mapModeloPizzaParaPrecificacao";
import { DirecaoOrdenacao, ordenarPorDescricao } from "../utils/ordenarPorDescricao";
import { DirecaoPosicao, trocarPosicaoPorUuid } from "../utils/trocarPosicaoPorUuid";
import { IMPOSTO_PADRAO_PRODUCAO_PROPRIA } from "../constants/imposto";

interface ICadastrarEditarProdutoContext {
    handleTipoProduto: (tipo: TipoProduto | undefined) => void;
    handleExcluirImagem: (imagemExcluida: File | IImagemProduto) => void;
    handleUploadImagem: (arquivo: File) => void;
    tipoProduto: TipoProduto | undefined;
    step: number;
    descricao: string | undefined
    modeloPrecificacao: ModeloPrecificacaoPizza | undefined
    quantidadeFatias: number | undefined
    quantidadeSabores: number | undefined
    imagens: IImagemProduto[] | File[];
    marca?: string;
    codigoBarras?: string;
    preco?: string;
    precoSemDesconto?: string;
    detalhes?: string;
    serve?: number;

    handleVoltar: () => void;
    handleProximo: () => void;
    setStep: (step: number) => void;

    imposto: IImpostoProduto | undefined;
    setImposto: (imposto: IImpostoProduto | undefined) => void;

    consultarIndustrializado: ({ codigoBarras }: FieldValues) => void;

    editarBorda: (borda: IBorda) => void;
    excluirBorda: (borda: IBorda) => void;
    adicionarBorda: (borda: IBorda) => void;
    ordenarBordas: (direcao: DirecaoOrdenacao) => void;
    trocarPosicaoBorda: (uuid: string, direcao: DirecaoPosicao) => void;
    bordas: IBorda[];

    editarSabor: (sabor: ISabor) => void;
    excluirSabor: (sabor: ISabor) => void;
    adicionarSabor: (sabor: ISabor) => void;
    ordenarSabores: (direcao: DirecaoOrdenacao) => void;
    trocarPosicaoSabor: (uuid: string, direcao: DirecaoPosicao) => void;
    sabores: ISabor[];

    editarMassa: (massa: IMassa) => void;
    excluirMassa: (massa: IMassa) => void;
    adicionarMassa: (massa: IMassa) => void;
    ordenarMassas: (direcao: DirecaoOrdenacao) => void;
    trocarPosicaoMassa: (uuid: string, direcao: DirecaoPosicao) => void;
    massas: IMassa[];


    complementos?: IComplemento[];

    registrarConfiguracoesPizza: (pizza: FieldValues) => void;
    registrarConfiguracoesPreparado: (preparado: FieldValues) => void;
    registrarConfiguracoesPeso: (config: IConfiguracaoPeso) => void;
    configuracaoPeso: IConfiguracaoPeso | null;
    setDescricao: (descricao: string) => void;
    setModeloPrecificacao: (modeloPrecificacao: ModeloPrecificacaoPizza) => void;
    setQuantidadeFatias: (qtd: number) => void;
    setQuantidadeSabores: (qtd: number) => void;
    maxAdicionais: number | undefined;
    setMaxAdicionais: (val: number | undefined) => void;
    massaObrigatoria: boolean;
    setMassaObrigatoria: (val: boolean) => void;
    bordaObrigatoria: boolean;
    setBordaObrigatoria: (val: boolean) => void;
    setPreco: (preco: string) => void;
    setPrecoSemDesconto: (preco: string) => void;
    setCodigoBarras: (codigo: string) => void;
    setMarca: (marca: string) => void;
    setDetalhes: (detalhes: string) => void;
    setServe: (qtd: number | undefined) => void;
    salvarHabilitado: boolean;
    loading: boolean;
    salvarProduto: () => void;
    setImagens: (imagens: IImagemProduto[] | File[]) => void;

    categoriaUuid: string | undefined;
    setCategoriaUuid: (categoriaUuid: string) => void;
    categoria: ICategoria | undefined;
    loadingCategoria: boolean;

    uuid: string | undefined;
    setUuid: (uuid: string) => void;

    produto: IProduto | undefined;
    resetIndustrializado: () => void;
    validarIndustrializado: () => void;
    formErrors?: FormErrors;


    setHabilitarComplementos: (habilitar: boolean) => void;
    habilitarComplementos: boolean;
    setHabilitarObservacao: (habilitar: boolean) => void;
    habilitarObservacao: boolean;
    setComplementos: (complementos: IComplemento[]) => void;
    salvarComplemento: (complemento: IComplemento) => void;
    excluirComplemento: (uuid: string) => void;
    trocarPosicaoComplementos: (indexAtual: number, direcao: 'cima' | 'baixo') => void;
    ordenarComplementos: (direcao: DirecaoOrdenacao) => void;

    controleEstoque: TipoControleEstoque | undefined;
    setControleEstoque: (tipo: TipoControleEstoque | undefined) => void;

    configuracaoKDS: IConfiguracaoKDS | undefined;
    setConfiguracaoKDS: (config: IConfiguracaoKDS | undefined) => void;

    processosPreparoKDS: IProcessoPreparoKDS[];
    adicionarProcessoKDS: (processo: Omit<IProcessoPreparoKDS, 'uuid'>) => void;
    editarProcessoKDS: (uuid: string, dados: Partial<IProcessoPreparoKDS>) => void;
    removerProcessoKDS: (uuid: string) => void;

    adicionarInsumo: (insumo: IInsumo) => void;
    excluirInsumo: (uuid: string) => void;
    fichaTecnica: IInsumo[];

    adicionais: IAdicionalPizza[];
    adicionarAdicional: (adicional: IAdicionalPizza) => void;
    editarAdicional: (adicional: IAdicionalPizza) => void;
    excluirAdicional: (uuid: string) => void;
    ordenarAdicionais: (direcao: DirecaoOrdenacao) => void;
    trocarPosicaoAdicional: (uuid: string, direcao: DirecaoPosicao) => void;

    kdsDesabilitado: boolean;
    kdsSimples: boolean;

    itensCombo: IItemCombo[];
    adicionarItemCombo: (item: IItemCombo) => void;
    editarItemCombo: (uuid: string, dados: Partial<Pick<IItemCombo, 'preco' | 'quantidade' | 'produto'>>) => void;
    removerItemCombo: (uuid: string) => void;
    trocarPosicaoItemCombo: (indexAtual: number, direcao: 'cima' | 'baixo') => void;
    registrarConfiguracaoCombo: (dados: FieldValues) => void;
}

interface FormErrors {
    preco?: string;
    precoSemDesconto?: string;
    descricao?: string;
}

export const useCadastrarEditarProdutoContext = () => {
    return useContext(CadastrarEditarProdutoContext)
}
export const CadastrarEditarProdutoContext = createContext({} as ICadastrarEditarProdutoContext)

export const CadastrarEditarProdutoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [uuid, setUuid] = useState<string | undefined>(undefined);
    const [categoriaUuid, setCategoriaUuid] = useState<string | undefined>(undefined);
    const [categoria, setCategoria] = useState<ICategoria | undefined>(undefined)
    const { salvar, loading, consultarIndustrializado: consultarIndustrializadoHook } = useProdutos();
    const { kdsDesabilitado, kdsSimples } = useConfiguracaoKDS();
    const { buscar, loading: loadingCategoria } = useCategorias();
    const [step, setStep] = useState(0);
    const [tipoProduto, setTipoProduto] = useState<TipoProduto | undefined>(undefined);
    const [formErrors, setFormErrors] = useState<FormErrors>({});
    const navigate = useNavigate();

    const handleTipoProduto = (tipo: TipoProduto | undefined) => {
        setTipoProduto(tipo);
    }

    const { number } = useMoeda();
    const [imagens, setImagens] = useState<IImagemProduto[] | File[]>([]);
    const [bordas, setBordas] = useState<IBorda[]>([]);
    const [sabores, setSabores] = useState<ISabor[]>([]);
    const [massas, setMassas] = useState<IMassa[]>([]);
    const [descricao, setDescricao] = useState<string | undefined>('');
    const [modeloPrecificacao, setModeloPrecificacao] = useState<ModeloPrecificacaoPizza | undefined>(undefined);
    const [quantidadeFatias, setQuantidadeFatias] = useState(0);
    const [quantidadeSabores, setQuantidadeSabores] = useState(0);
    const [preco, setPreco] = useState('');
    const [precoSemDesconto, setPrecoSemDesconto] = useState('');
    const [codigoBarras, setCodigoBarras] = useState<string | undefined>('');
    const [marca, setMarca] = useState<string | undefined>('');
    const [imposto, setImposto] = useState<IImpostoProduto | undefined>(undefined);
    const [complementos, setComplementos] = useState<IComplemento[]>([]);
    const [habilitarComplementos, setHabilitarComplementos] = useState<boolean>(false);
    const [habilitarObservacao, setHabilitarObservacao] = useState<boolean>(false);
    const [detalhes, setDetalhes] = useState<string | undefined>('');
    const [serve, setServe] = useState<number | undefined>(0);
    const [controleEstoque, setControleEstoque] = useState<TipoControleEstoque | undefined>(undefined);
    const [fichaTecnica, setFichaTecnica] = useState<IInsumo[]>([]);
    const [configuracaoPeso, setConfiguracaoPeso] = useState<IConfiguracaoPeso | null>(null);
    const [configuracaoKDS, setConfiguracaoKDS] = useState<IConfiguracaoKDS | undefined>(undefined);
    const [processosPreparoKDS, setProcessosPreparoKDS] = useState<IProcessoPreparoKDS[]>([]);
    const [adicionais, setAdicionais] = useState<IAdicionalPizza[]>([]);
    const [maxAdicionais, setMaxAdicionais] = useState<number | undefined>(undefined);
    const [massaObrigatoria, setMassaObrigatoria] = useState<boolean>(false);
    const [bordaObrigatoria, setBordaObrigatoria] = useState<boolean>(false);
    const [itensCombo, setItensCombo] = useState<IItemCombo[]>([]);

    const adicionarProcessoKDS = (processo: Omit<IProcessoPreparoKDS, 'uuid'>) => {
        setProcessosPreparoKDS(prev => [...prev, { ...processo, uuid: v4() }]);
    };

    const editarProcessoKDS = (processoUuid: string, dados: Partial<IProcessoPreparoKDS>) => {
        setProcessosPreparoKDS(prev => prev.map(p => p.uuid === processoUuid ? { ...p, ...dados } : p));
    };

    const removerProcessoKDS = (processoUuid: string) => {
        setProcessosPreparoKDS(prev => prev.filter(p => p.uuid !== processoUuid));
    };

    const adicionarItemCombo = (item: IItemCombo) => {
        setItensCombo(prev => [...prev, item]);
    };

    const editarItemCombo = (itemUuid: string, dados: Partial<Pick<IItemCombo, 'preco' | 'quantidade' | 'produto'>>) => {
        setItensCombo(prev => prev.map(i => i.uuid === itemUuid ? { ...i, ...dados } : i));
    };

    const removerItemCombo = (itemUuid: string) => {
        setItensCombo(prev => prev.filter(i => i.uuid !== itemUuid));
    };

    const trocarPosicaoItemCombo = (indexAtual: number, direcao: 'cima' | 'baixo') => {
        setItensCombo((prev) => {
            const novoArray = [...prev];
            const novoIndex = direcao === 'cima' ? indexAtual - 1 : indexAtual + 1;

            if (novoIndex < 0 || novoIndex >= novoArray.length) return prev;

            [novoArray[indexAtual], novoArray[novoIndex]] = [novoArray[novoIndex], novoArray[indexAtual]];

            return novoArray;
        });
    };

    const registrarConfiguracaoCombo = (dados: FieldValues) => {
        setDescricao(dados.descricao);
        setDetalhes(dados.detalhes);
        setPreco(dados.preco);
        setPrecoSemDesconto(dados.precoSemDesconto);
        handleProximo();
    };

    const gerarComplementosDoCombo = (itens: IItemCombo[]): IComplemento[] => {
        const complementos: IComplemento[] = [];

        for (const item of itens) {
            const { produto, herdarPrecoComplementos } = item;

            if (produto.tipo === TipoProduto.pizza) {
                if (produto.sabores?.length) {
                    complementos.push({
                        uuid: v4(),
                        descricao: `Sabores — ${produto.descricao}`,
                        obrigatorio: true,
                        numeroMinimoItens: 1,
                        numeroMaximoItens: produto.quantidadeSabores ?? 1,
                        precificacao: mapModeloPizzaParaPrecificacao(produto.configuracao?.modeloPrecificacao),
                        itens: produto.sabores.map(s => ({
                            uuid: v4(),
                            descricao: s.descricao,
                            preco: s.preco ?? 0,
                            precoSemDesconto: s.precoSemDesconto,
                            imagens: s.imagens ?? [],
                        }))
                    });
                }
                if (produto.bordas?.length) {
                    complementos.push({
                        uuid: v4(),
                        descricao: `Bordas — ${produto.descricao}`,
                        obrigatorio: produto.configuracao?.bordaObrigatoria ?? false,
                        numeroMinimoItens: produto.configuracao?.bordaObrigatoria ? 1 : 0,
                        numeroMaximoItens: 1,
                        itens: produto.bordas.map(b => ({
                            uuid: v4(),
                            descricao: b.descricao,
                            preco: b.preco ?? 0,
                            precoSemDesconto: b.precoSemDesconto,
                            imagens: b.imagens ?? [],
                        }))
                    });
                }
                if (produto.massas?.length) {
                    complementos.push({
                        uuid: v4(),
                        descricao: `Massas — ${produto.descricao}`,
                        obrigatorio: produto.configuracao?.massaObrigatoria ?? false,
                        numeroMinimoItens: produto.configuracao?.massaObrigatoria ? 1 : 0,
                        numeroMaximoItens: 1,
                        itens: produto.massas.map(m => ({
                            uuid: v4(),
                            descricao: m.descricao,
                            preco: m.preco ?? 0,
                            precoSemDesconto: m.precoSemDesconto,
                            imagens: m.imagens ?? [],
                        }))
                    });
                }
                if (produto.adicionais?.length) {
                    complementos.push({
                        uuid: v4(),
                        descricao: `Adicionais — ${produto.descricao}`,
                        obrigatorio: false,
                        numeroMinimoItens: 0,
                        numeroMaximoItens: produto.configuracao?.maxAdicionais ?? produto.adicionais.length,
                        itens: produto.adicionais.map(a => ({
                            uuid: v4(),
                            descricao: a.descricao,
                            preco: a.preco ?? 0,
                            precoSemDesconto: a.precoSemDesconto,
                            imagens: a.imagens ?? [],
                        }))
                    });
                }
            }

            if (produto.tipo === TipoProduto.preparado) {
                produto.complementos?.forEach(comp => {
                    complementos.push({
                        ...comp,
                        uuid: v4(),
                        descricao: `${produto.descricao} — ${comp.descricao}`,
                        itens: comp.itens.map(it => ({
                            ...it,
                            uuid: v4(),
                            preco: it.preco ?? 0,
                            precoSemDesconto: it.precoSemDesconto,
                        }))
                    });
                });
            }
        }

        return complementos;
    };

    const snackbar = useSnackbar();
    const buscarCategoria = async (categoriaUuid: string) => {
        if (!categoriaUuid) {
            return;
        }

        const dados = await buscar(categoriaUuid);
        if (!dados) {
            navigate("/cardapio");
            snackbar("Categoria não encontrada", { severity: "error" })
            return;
        }
        setCategoria(dados);
    }

    const adicionarInsumo = (insumo: IInsumo) => {
        setFichaTecnica(ficha => [...ficha, insumo]);
    }

    const excluirInsumo = (uuid: string) => {
        setFichaTecnica(ficha => ficha.filter(insumo => insumo.uuid !== uuid));
    }

    const produto = useMemo(() => {
        return categoria?.produtos?.find(produto => produto.uuid === uuid);
    }, [uuid, categoria])

    const validarIndustrializado = (): boolean => {
        const currentErrors: FormErrors = {};

        const validacaoMoeda = validarMoedaReal(preco?.trim(), 0.00, undefined, true);
        if (validacaoMoeda) {
            currentErrors.preco = validacaoMoeda;
        }

        if (precoSemDesconto?.length) {
            const validacaoMoeda = validarMoedaReal(precoSemDesconto?.trim(), 0.00, undefined, true);
            if (validacaoMoeda) {
                currentErrors.precoSemDesconto = validacaoMoeda;
            }
        }

        if(!descricao) {
            currentErrors.descricao = 'Descrição inválida';
        }

        setFormErrors(currentErrors);
        return Object.keys(currentErrors).length === 0;
    };

    const trocarPosicaoComplementos = (indexAtual: number, direcao: 'cima' | 'baixo') => {
        setComplementos((prev) => {
            const novoArray = [...prev];
            const novoIndex = direcao === 'cima' ? indexAtual - 1 : indexAtual + 1;

            if (novoIndex < 0 || novoIndex >= novoArray.length) return prev;

            [novoArray[indexAtual], novoArray[novoIndex]] = [novoArray[novoIndex], novoArray[indexAtual]];

            return novoArray;
        });
    }

    const ordenarComplementos = (direcao: DirecaoOrdenacao) => {
        setComplementos(complementos => ordenarPorDescricao(complementos, direcao));
    }


    const consultarIndustrializado = async ({ codigoBarras }: FieldValues) => {
        const produto = await consultarIndustrializadoHook(codigoBarras.trim());

        if (!produto) {
            return snackbar("Produto não encontrado", { severity: "error" });
        }

        setImagens(produto.imagens);
        setDescricao(produto.descricao);
        setCodigoBarras(codigoBarras);
        setMarca(produto.marca);
        setUuid(produto.uuid);
        setImposto(produto.imposto);
        handleProximo();
    }

    const resetIndustrializado = () => {
        setPreco('');
        setPrecoSemDesconto('');
        setDescricao(undefined);
        setImagens([]);
        setMarca(undefined);
        setCodigoBarras(undefined);
        setUuid(undefined);
    }

    useEffect(() => {
        if (categoriaUuid) {
            buscarCategoria(categoriaUuid);
        }
    }, [categoriaUuid])

    useEffect(() => {
        if (produto) {
            setTipoProduto(produto?.tipo);
            setDescricao(produto?.descricao);
            if (produto?.configuracaoPeso) {
                setConfiguracaoPeso(produto.configuracaoPeso);
            } else if (produto?.tipo === TipoProduto.peso && produto?.configuracao?.precoPorKg) {
                setConfiguracaoPeso({ precoPorKg: produto.configuracao.precoPorKg, valorTeto: produto.configuracao.valorTeto });
            }
            setServe(produto?.serve);
            setModeloPrecificacao(produto?.configuracao?.modeloPrecificacao);
            setQuantidadeFatias(produto?.quantidadeFatias ?? 0);
            setQuantidadeSabores(produto?.quantidadeSabores ?? 0);
            setImagens(produto?.imagens as any);
            setBordas(produto?.bordas ?? []);
            setMassas(produto?.massas ?? []);
            setSabores(produto?.sabores ?? []);
            setMarca(produto?.marca);
            setCodigoBarras(produto?.codigoBarras);
            setPreco(produto?.preco ? String(produto?.preco) : '');
            setPrecoSemDesconto(produto?.precoSemDesconto ? String(produto?.precoSemDesconto) : '');
            setImposto(produto?.imposto);
            setDetalhes(produto?.detalhes);
            setComplementos(produto?.complementos ?? []);
            setHabilitarComplementos(produto?.configuracao?.habilitarComplementos ?? false);
            setHabilitarObservacao(produto?.configuracao?.habilitarObservacao ?? false);
            setControleEstoque(produto?.controleEstoque);
            setFichaTecnica(produto?.fichaTecnica ?? []);
            setConfiguracaoKDS(produto?.configuracaoKDS);
            setProcessosPreparoKDS(produto?.processosPreparoKDS ?? []);
            setAdicionais(produto?.adicionais ?? []);
            setMaxAdicionais(produto?.configuracao?.maxAdicionais ?? undefined);
            setMassaObrigatoria(produto?.configuracao?.massaObrigatoria ?? false);
            setBordaObrigatoria(produto?.configuracao?.bordaObrigatoria ?? false);
            setItensCombo(produto?.itensCombo ?? []);
        }
    }, [produto])

    const mimetypesValidos = [
        MIMETypes["image/jpeg"],
        MIMETypes["image/jpg"],
        MIMETypes["image/png"]
    ] as string[];

    const salvarProduto = async () => {
        if (!categoriaUuid) {
            return;
        }

        const uuidSalvar = uuid ?? v4();
        if (tipoProduto == TipoProduto.pizza) {
            if (!descricao) {
                return snackbar("Tamanho inválido", { severity: "error" })
            }

            if (!modeloPrecificacao) {
                return snackbar("Modelo de precificação inválido", { severity: "error" })
            }

            const resultado = await salvar(categoriaUuid, {
                tipo: tipoProduto,
                descricao,
                uuid: uuidSalvar,
                bordas,
                sabores,
                massas,
                adicionais,
                quantidadeFatias,
                quantidadeSabores,
                imagens: imagens as any,
                controleEstoque,
                fichaTecnica,
                serve,
                configuracaoKDS,
                processosPreparoKDS,
                imposto: imposto ?? IMPOSTO_PADRAO_PRODUCAO_PROPRIA,
                configuracao: {
                    modeloPrecificacao,
                    maxAdicionais: maxAdicionais ?? undefined,
                    massaObrigatoria,
                    bordaObrigatoria,
                },
            });

            if (!resultado) {
                return snackbar("Ocorreu um erro ao salvar o produto", { severity: "error" })
            }
        }

        if (tipoProduto == TipoProduto.industrializado) {
            if (!validarIndustrializado()) {
                return;
            }

            setFormErrors({});

            if (!codigoBarras) {
                return snackbar("Código de barras inválido", { severity: "error" })
            }

            if (!descricao) {
                return snackbar("Descrição inválida", { severity: "error" })
            }

            const resultado = await salvar(categoriaUuid, {
                tipo: tipoProduto,
                descricao,
                uuid: uuidSalvar,
                codigoBarras,
                marca,
                imagens: imagens as any,
                imposto,
                serve,
                preco: preco.length ? number(preco) : 0,
                precoSemDesconto: precoSemDesconto?.length ? number(precoSemDesconto) : undefined,
                controleEstoque,
                fichaTecnica,
                configuracaoKDS,
                processosPreparoKDS,
            });

            if (!resultado) {
                return snackbar("Ocorreu um erro ao salvar o produto", { severity: "error" })
            }
        }

        if (tipoProduto == TipoProduto.preparado) {
            if (!descricao) {
                return snackbar("Descrição inválida", { severity: "error" })
            }

            if (detalhes && (detalhes?.length > 720)) {
                return snackbar("O campo 'detalhes' não pode ter mais que 720 caracteres", { severity: "error" })
            }

            const resultado = await salvar(categoriaUuid, {
                tipo: tipoProduto,
                descricao,
                uuid: uuidSalvar,
                preco: preco.length ? number(preco) : 0,
                precoSemDesconto: precoSemDesconto.length ? number(precoSemDesconto) : undefined,
                complementos,
                detalhes,
                imagens: imagens as any,
                controleEstoque,
                fichaTecnica,
                serve,
                configuracaoKDS,
                processosPreparoKDS,
                imposto: imposto ?? IMPOSTO_PADRAO_PRODUCAO_PROPRIA,
                configuracao: {
                    habilitarComplementos,
                    habilitarObservacao
                }
            });

            if (!resultado) {
                return snackbar("Ocorreu um erro ao salvar o produto", { severity: "error" })
            }
        }

        if (tipoProduto == TipoProduto.combo) {
            if (!descricao) {
                return snackbar("Descrição inválida", { severity: "error" });
            }

            if (!itensCombo.length) {
                return snackbar("Adicione ao menos um produto ao combo", { severity: "error" });
            }

            const complementosGerados = gerarComplementosDoCombo(itensCombo);

            const resultado = await salvar(categoriaUuid, {
                tipo: tipoProduto,
                descricao,
                uuid: uuidSalvar,
                preco: preco.length ? number(preco) : 0,
                precoSemDesconto: precoSemDesconto.length ? number(precoSemDesconto) : undefined,
                detalhes,
                imagens: imagens as any,
                itensCombo,
                complementos: complementosGerados,
                imposto: imposto ?? IMPOSTO_PADRAO_PRODUCAO_PROPRIA,
                configuracao: {
                    habilitarComplementos: complementosGerados.length > 0,
                    habilitarObservacao: false,
                },
            } as any);

            if (!resultado) {
                return snackbar("Ocorreu um erro ao salvar o produto", { severity: "error" });
            }
        }

        if (tipoProduto == TipoProduto.peso) {
            if (!descricao) {
                return snackbar("Descrição inválida", { severity: "error" })
            }

            if (!configuracaoPeso?.precoPorKg || configuracaoPeso.precoPorKg <= 0) {
                return snackbar("Preço por kg inválido", { severity: "error" })
            }

            const resultado = await salvar(categoriaUuid, {
                tipo: tipoProduto,
                descricao,
                uuid: uuidSalvar,
                imagens: imagens as any,
                controleEstoque,
                fichaTecnica,
                imposto: imposto ?? IMPOSTO_PADRAO_PRODUCAO_PROPRIA,
                configuracao: configuracaoPeso,
            } as any);

            if (!resultado) {
                return snackbar("Ocorreu um erro ao salvar o produto", { severity: "error" })
            }
        }

        snackbar("Produto salvo com sucesso", { severity: "success" })
        navigate("/cardapio");
    }

    const adicionarBorda = (borda: IBorda) => {
        setBordas((bordas) => [...bordas, {
            ...borda,
            uuid: v4()
        }]);
    }

    const adicionarSabor = (sabor: ISabor) => {
        setSabores((sabores) => [...sabores, {
            ...sabor,
            uuid: v4()
        }]);
    }

    const adicionarMassa = (massa: IMassa) => {
        setMassas((massas) => [...massas, {
            ...massa,
            uuid: v4()
        }]);
    }

    const editarBorda = (borda: IBorda) => {
        const index = bordas.findIndex(bordaIndex => bordaIndex.uuid === borda.uuid)

        if (index != -1) {
            const novasBordas = bordas;
            bordas[index] = borda;
            setBordas([...novasBordas]);
        }
    }

    const editarSabor = (sabor: ISabor) => {
        const index = sabores.findIndex(saborIndex => saborIndex.uuid === sabor.uuid)

        if (index != -1) {
            const novosSabores = sabores;
            novosSabores[index] = sabor;
            setSabores([...novosSabores]);
        }
    }


    const editarMassa = (massa: IMassa) => {
        const index = massas.findIndex(massaIndex => massaIndex.uuid === massa.uuid)

        if (index != -1) {
            const novasMassas = massas;
            novasMassas[index] = massa;
            setMassas([...novasMassas]);
        }
    }

    const excluirBorda = (borda: IBorda) => {
        const index = bordas.findIndex(bordaIndex => bordaIndex.uuid === borda.uuid)

        if (index != -1) {
            const novasBordas = bordas;
            novasBordas.splice(index, 1);
            setBordas([...novasBordas]);
        }
    }

    const excluirSabor = (sabor: ISabor) => {
        const index = sabores.findIndex(saborIndex => saborIndex.uuid === sabor.uuid);

        if (index != -1) {
            const novosSabores = sabores;
            novosSabores.splice(index, 1);
            setSabores([...novosSabores]);
        }
    }

    const excluirMassa = (massa: IMassa) => {
        const index = massas.findIndex(massaIndex => massaIndex.uuid === massa.uuid);

        if (index != -1) {
            const novasMassas = massas;
            novasMassas.splice(index, 1);
            setMassas([...novasMassas]);
        }
    }

    const ordenarBordas = (direcao: DirecaoOrdenacao) => {
        setBordas(bordas => ordenarPorDescricao(bordas, direcao));
    }

    const ordenarSabores = (direcao: DirecaoOrdenacao) => {
        setSabores(sabores => ordenarPorDescricao(sabores, direcao));
    }

    const ordenarMassas = (direcao: DirecaoOrdenacao) => {
        setMassas(massas => ordenarPorDescricao(massas, direcao));
    }

    // Ordem escolhida a dedo, item por item — a alfabética resolve a lista
    // grande, mas quem monta cardápio quer o sabor que vende na frente.
    const trocarPosicaoBorda = (uuid: string, direcao: DirecaoPosicao) => {
        setBordas(bordas => trocarPosicaoPorUuid(bordas, uuid, direcao));
    }

    const trocarPosicaoSabor = (uuid: string, direcao: DirecaoPosicao) => {
        setSabores(sabores => trocarPosicaoPorUuid(sabores, uuid, direcao));
    }

    const trocarPosicaoMassa = (uuid: string, direcao: DirecaoPosicao) => {
        setMassas(massas => trocarPosicaoPorUuid(massas, uuid, direcao));
    }

    const handleExcluirImagem = (imagemExcluida: File | IImagemProduto) => {
        setImagens([]);
    }

    const handleUploadImagem = (arquivo: File) => {
        if (!mimetypesValidos.includes(arquivo.type)) {
            return snackbar(`Arquivo inválido, tipos aceitos: (PNG, JPEG)`, { severity: "error" })
        }

        setImagens([arquivo]);
    }

    const handleVoltar = () => {
        if ((step - 1) < 0) {
            if (tipoProduto) {
                return setTipoProduto(undefined);
            }
            return navigate("/cardapio");
        }

        setStep(step - 1);
    }

    const handleProximo = () => {
        setStep(step + 1);
    }

    const registrarConfiguracoesPizza = (pizza: FieldValues) => {
        setDescricao(pizza.descricao);
        setModeloPrecificacao(pizza.modeloPrecificacao);
        setQuantidadeSabores(Number(pizza.quantidadeSabores));
        setQuantidadeFatias(Number(pizza.quantidadeFatias));
        setMaxAdicionais(pizza.maxAdicionais !== undefined && pizza.maxAdicionais !== '' ? Number(pizza.maxAdicionais) : undefined);
        setMassaObrigatoria(pizza.massaObrigatoria ?? false);
        setBordaObrigatoria(pizza.bordaObrigatoria ?? false);
        handleProximo();
    }

    const registrarConfiguracoesPreparado = (preparado: FieldValues) => {
        setDescricao(preparado.descricao);
        setDetalhes(preparado.detalhes);
        setPreco(preparado.preco);
        setPrecoSemDesconto(preparado.precoSemDesconto);
        handleProximo();
    }

    const registrarConfiguracoesPeso = (config: IConfiguracaoPeso) => {
        setConfiguracaoPeso(config);
        handleProximo();
    }

    const salvarHabilitado = useMemo(() => {
        if (tipoProduto == TipoProduto.pizza) {
            if (!descricao?.length) {
                return false;
            }

            if (!modeloPrecificacao?.length) {
                return false;
            }

            if (!quantidadeFatias || quantidadeFatias <= 0) {
                return false;
            }

            if (!quantidadeSabores || quantidadeSabores <= 0) {
                return false;
            }

            if (!uuid && step < 6) {
                return false;
            }

            return true;
        }

        if (tipoProduto == TipoProduto.industrializado) {
            if (!codigoBarras) {
                return false;
            }

            if (!descricao) {
                return false;
            }

            if (step < 3) {
                return false;
            }

            return true;
        }

        if (tipoProduto == TipoProduto.preparado) {
            if (!descricao) {
                return false;
            }

            if (!uuid && step < 2) {
                return false;
            }

            return true;
        }

        if (tipoProduto == TipoProduto.peso) {
            if (!descricao) {
                return false;
            }

            if (!configuracaoPeso?.precoPorKg) {
                return false;
            }

            // habilitado a partir do "Controle de estoque" (step 1), incluindo o step "Fiscal" (2)
            if (step < 1) {
                return false;
            }

            return true;
        }

        if (tipoProduto == TipoProduto.combo) {
            if (!descricao) {
                return false;
            }

            if (!itensCombo.length) {
                return false;
            }

            // "Produtos" (step 1) é o último passo do combo; KDS/estoque agora são por produto do combo.
            if (!uuid && step < 1) {
                return false;
            }

            return true;
        }

        return false;
    }, [
        tipoProduto,
        step,
        descricao,
        modeloPrecificacao,
        quantidadeFatias,
        quantidadeSabores,
        configuracaoPeso,
        itensCombo
    ])


    const salvarComplemento = (complemento: IComplemento) => {
        const indexComplemento = complementos?.findIndex(item => item.uuid === complemento.uuid);

        if (indexComplemento != -1) {
            const novosComplementos = complementos;
            novosComplementos[indexComplemento] = complemento;
            setComplementos([...novosComplementos]);
            return;
        }

        setComplementos((estado) => [...estado, complemento]);
    }

    const adicionarAdicional = (adicional: IAdicionalPizza) => {
        setAdicionais((prev) => [...prev, { ...adicional, uuid: v4() }]);
    }

    const editarAdicional = (adicional: IAdicionalPizza) => {
        const index = adicionais.findIndex(a => a.uuid === adicional.uuid);
        if (index !== -1) {
            const novos = [...adicionais];
            novos[index] = adicional;
            setAdicionais(novos);
        }
    }

    const excluirAdicional = (uuid: string) => {
        setAdicionais(prev => prev.filter(a => a.uuid !== uuid));
    }

    const ordenarAdicionais = (direcao: DirecaoOrdenacao) => {
        setAdicionais(adicionais => ordenarPorDescricao(adicionais, direcao));
    }

    const trocarPosicaoAdicional = (uuid: string, direcao: DirecaoPosicao) => {
        setAdicionais(adicionais => trocarPosicaoPorUuid(adicionais, uuid, direcao));
    }

    const excluirComplemento = (uuid: string) => {
        const index = complementos?.findIndex(complemento => complemento.uuid == uuid);

        if (index == -1) {
            return snackbar("Complemento não encontrado", { severity: "error" })
        }

        const novoArray = complementos;
        novoArray.splice(index, 1);
        setComplementos([...novoArray]);
    }


    return (
        <CadastrarEditarProdutoContext.Provider value={{
            tipoProduto,
            handleTipoProduto,
            step,
            handleExcluirImagem,
            handleUploadImagem,
            descricao,
            modeloPrecificacao,
            quantidadeFatias,
            quantidadeSabores,
            imagens,
            handleVoltar,
            handleProximo,
            setStep,
            imposto,
            setImposto,
            bordas,
            adicionarBorda,
            editarBorda,
            excluirBorda,
            ordenarBordas,
            trocarPosicaoBorda,
            registrarConfiguracoesPizza,
            setDescricao,
            setModeloPrecificacao,
            setQuantidadeFatias,
            setQuantidadeSabores,
            sabores,
            adicionarSabor,
            editarSabor,
            excluirSabor,
            ordenarSabores,
            trocarPosicaoSabor,
            salvarHabilitado,
            loading,
            salvarProduto,
            uuid,
            setUuid,
            setCategoriaUuid,
            categoriaUuid,
            categoria,
            loadingCategoria,
            produto,
            consultarIndustrializado,
            marca,
            codigoBarras,
            preco,
            setPreco,
            precoSemDesconto,
            setPrecoSemDesconto,
            setMarca,
            setCodigoBarras,
            resetIndustrializado,
            validarIndustrializado,
            formErrors,
            setImagens,
            setComplementos,
            complementos,
            habilitarComplementos,
            habilitarObservacao,
            setHabilitarComplementos,
            setHabilitarObservacao,
            setDetalhes,
            detalhes,
            registrarConfiguracoesPreparado,
            registrarConfiguracoesPeso,
            configuracaoPeso,
            salvarComplemento,
            excluirComplemento,
            controleEstoque,
            setControleEstoque,
            fichaTecnica,
            adicionarInsumo,
            excluirInsumo,
            setServe,
            serve,
            massas,
            adicionarMassa,
            editarMassa,
            excluirMassa,
            ordenarMassas,
            trocarPosicaoMassa,
            trocarPosicaoComplementos,
            ordenarComplementos,
            configuracaoKDS,
            setConfiguracaoKDS,
            processosPreparoKDS,
            adicionarProcessoKDS,
            editarProcessoKDS,
            removerProcessoKDS,
            adicionais,
            adicionarAdicional,
            editarAdicional,
            excluirAdicional,
            ordenarAdicionais,
            trocarPosicaoAdicional,
            maxAdicionais,
            setMaxAdicionais,
            massaObrigatoria,
            setMassaObrigatoria,
            bordaObrigatoria,
            setBordaObrigatoria,
            kdsDesabilitado,
            kdsSimples,
            itensCombo,
            adicionarItemCombo,
            editarItemCombo,
            removerItemCombo,
            trocarPosicaoItemCombo,
            registrarConfiguracaoCombo,
        }}>
            {children}
        </CadastrarEditarProdutoContext.Provider>
    );
} 